var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitItemData($event)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("div", {
              staticClass: "col-md-12",
              domProps: { innerHTML: _vm._s(_vm.message) },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "col-md-12",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
            _vm._v(" "),
            _c(
              "table-component",
              {
                ref: "table",
                attrs: {
                  "show-filter": false,
                  data: _vm.attachments,
                  "table-class": "table",
                },
              },
              [
                _c("table-column", {
                  attrs: {
                    label: _vm.$tc("documents.documentType", 2),
                    show: "documentType.name",
                  },
                }),
                _vm._v(" "),
                _c("table-column", {
                  attrs: { label: _vm.$t("documents.document"), show: "name" },
                }),
                _vm._v(" "),
                _c("table-column", {
                  attrs: {
                    sortable: false,
                    filterable: false,
                    "cell-class": "action-dropdown",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("customers.action")) + " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-dropdown",
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "activator", href: "#" },
                                  slot: "activator",
                                },
                                [_c("dot-icon")],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-dropdown-item", [
                                _c("div", { staticClass: "dropdown-item" }, [
                                  row.path
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: row.path,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "dropdown-item-icon",
                                            attrs: { icon: "eye" },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("general.view")) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "card-footer justify-content-between align-items-center",
          },
          [
            _c("div", [
              _c("div", { staticClass: "custom-control custom-checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmContract,
                      expression: "confirmContract",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { id: "confirm", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.confirmContract)
                      ? _vm._i(_vm.confirmContract, null) > -1
                      : _vm.confirmContract,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.confirmContract,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.confirmContract = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmContract = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmContract = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "confirm" },
                  },
                  [_vm._v("Confirm Contract")]
                ),
              ]),
              _vm._v(" "),
              _vm.$v.confirmContract.$error
                ? _c("div", [
                    !_vm.$v.confirmContract.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "mr-3",
                    attrs: { outline: true, color: "theme", type: "button" },
                    on: { click: _vm.closeItemModal },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("general.cancel")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "base-button",
                      {
                        attrs: { loading: _vm.isLoading, color: "theme" },
                        on: { click: _vm.submitItemData },
                      },
                      [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
                    )
                  : _c(
                      "base-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("general.save")) +
                            "\n        "
                        ),
                      ]
                    ),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }